import { Box, Skeleton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  identity: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  identityText: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  tabs: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  cards: {
    display: 'flex',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  card: {
    flex: 1,
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.border.card}`,
    borderRadius: 4,
  },
}));

const PartyInfoSkeleton = () => {
  const classes = useStyles();

  return (
    <Box aria-busy="true">
      <Box className={classes.identity}>
        <Skeleton variant="circular" animation="wave" width={48} height={48} />
        <Box className={classes.identityText}>
          <Skeleton variant="text" animation="wave" width="45%" height={28} />
          <Skeleton variant="text" animation="wave" width="30%" height={18} />
        </Box>
      </Box>
      <Skeleton variant="rectangular" animation="wave" height={1} />
      <Box className={classes.tabs}>
        <Skeleton variant="rectangular" animation="wave" width="40%" height={36} />
      </Box>
      <Box className={classes.cards}>
        {[1, 2].map((card) => (
          <Box key={card} className={classes.card}>
            <Skeleton variant="text" animation="wave" width="50%" height={24} />
            <Skeleton variant="rectangular" animation="wave" height={96} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PartyInfoSkeleton;
